export const actions = {
  PUT: 'PUT',
  GET: 'GET',
  REMOVE: 'REMOVE',
  SET: 'SET',

  put({device, state}) {
    return {
      type: actions.PUT,
      device,
      state
    }
  },

  remove(device) {
    return {
      type: actions.REMOVE,
      device
    }
  },

  set(devices) {
    return {
      type: actions.SET,
      devices
    }
  }
}

export const StateActions = actions
